module.exports = __webpack_public_path__ + "img/detail-bg.0d6812da.png";